import { useEffect, useState } from 'react';

import { publicEnv } from '@/lib/env';
import { LeagueSearch } from '@/modules/league/new-components/types';
import { checkIfValidUUID } from '@/utils/helpers/uuid';

export function useLeagueCardHref(league: LeagueSearch, isManagingCard?: boolean) {
  const { LeagueID, slug, LeagueSessionID, LeagueSessionID_Cur, LeagueSessionID_Nxt } = league;
  const [pbracketsURL, setPbracketsURL] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const url = new URL(`${publicEnv.NEXT_PUBLIC_PBRACKETS_URL}/redirect_r.aspx`);
      url.searchParams.set('mf', 'l');
      url.searchParams.set('mid', LeagueID);
      url.searchParams.set('todo', 'm');
      url.searchParams.set('rurl', window.location.href);
      setPbracketsURL(url.toString());
    }
  }, [LeagueID]);

  const internalHref = `${publicEnv.NEXT_PUBLIC_PL_URL}/leagues/${slug || LeagueID}/session/${
    LeagueSessionID || LeagueSessionID_Cur || LeagueSessionID_Nxt
  }?tab=standings`;

  const isUUID = checkIfValidUUID(LeagueID);
  const href = isManagingCard
    ? pbracketsURL
    : isUUID
      ? internalHref
      : `${publicEnv.NEXT_PUBLIC_PBRACKETS_URL}/lgd.aspx?lid=${LeagueID}`;
  const isExternal = isManagingCard || !isUUID;

  return { href, isExternal };
}
